import React from 'react'
import Carousel from 'react-material-ui-carousel'

// --- الواردات القديمة (تم إيقافها) ---
/*
import M1 from './../assets/Service/M8.jpg'
import M2 from './../assets/Service/M11.jpg'
import M3 from './../assets/Service/M10.jpg'
import M4 from './../assets/Service/M14.jpg'
import M5 from './../assets/Service/M15.jpg'
import M7 from './../assets/Service/M2.jpg'
*/

// --- استيراد الصور الجديدة من مجلد pro ---
import p1 from './../assets/pro/1.jpeg'
import p2 from './../assets/pro/2.jpeg'
import p3 from './../assets/pro/3.jpeg'
import p4 from './../assets/pro/4.jpeg'
import p5 from './../assets/pro/5.jpeg'
import p6 from './../assets/pro/6.jpeg'
import p7 from './../assets/pro/7.jpeg'
import p8 from './../assets/pro/8.jpeg'
import p9 from './../assets/pro/9.jpeg'
import p10 from './../assets/pro/10.jpeg'
// import p11 from './../assets/pro/11.jpeg'
// import p12 from './../assets/pro/12.jpeg'
// import p13 from './../assets/pro/13.jpeg'
// import p14 from './../assets/pro/14.jpeg'
// import p15 from './../assets/pro/15.jpeg'
// import p16 from './../assets/pro/16.jpeg'
// import p17 from './../assets/pro/17.jpeg'
// import p18 from './../assets/pro/18.jpeg'
// import p19 from './../assets/pro/19.jpeg'
// import p20 from './../assets/pro/20.jpeg'
// import p21 from './../assets/pro/21.jpeg'
// import p22 from './../assets/pro/22.jpeg'
// import p23 from './../assets/pro/23.jpeg'
// import p24 from './../assets/pro/24.jpeg'
// import p25 from './../assets/pro/25.jpeg'
// import p26 from './../assets/pro/26.jpeg'
// import p27 from './../assets/pro/27.jpeg'
// import p28 from './../assets/pro/28.jpeg'
// import p29 from './../assets/pro/29.jpeg'
// import p30 from './../assets/pro/30.jpeg'
// import p31 from './../assets/pro/31.jpeg'
// import p32 from './../assets/pro/32.jpeg'
// import p33 from './../assets/pro/33.jpeg'
// import p34 from './../assets/pro/34.jpeg'
// import p35 from './../assets/pro/35.jpeg'
// import p36 from './../assets/pro/36.jpeg'
// import p37 from './../assets/pro/37.jpeg'
// import p38 from './../assets/pro/38.jpeg'
// import p39 from './../assets/pro/39.jpeg'
// import p40 from './../assets/pro/40.jpeg'
// import p41 from './../assets/pro/41.jpeg'

function SumServ() {
    // وضع جميع الصور في مصفوفة لتسهيل عرضها
    const carouselImages = [
        p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, 
        // p11, p12, p13, p14, p15, p16, p17, p18, p19, p20, 
        // p21, p22, p23, p24, p25, p26, p27, p28, p29, p30, 
        // p31, p32, p33, p34, p35, p36, p37, p38, p39, p40, p41
    ];

    return (
        <>
            <Carousel
                className={'animated fadeInDown delay-3s'}
                height={400}
                sx={{
                    marginTop: "25px",
                    width: { md: "50%", xs: "100%" },
                    margin: "auto"
                }}>
                {carouselImages.map((image, index) => (
                    <a key={index} href={image} target='_blank' rel="noreferrer" >
                        <img
                            fetchpriority="high"
                            src={image}
                            alt={`Slide ${index + 1}`}
                            style={{
                                height: 400,
                                borderRadius: "20px",
                                width: "100%",
                                objectFit: "cover",
                            }}
                        />
                    </a>
                ))}
            </Carousel>
        </>
    )
}

export default SumServ